import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Layout from '@/layout'
export const constantRoutes = [
  {
    path: '',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  { path: '/callback', component: () => import('@/views/login/logout'), hidden: true },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [{
  //     path: 'dashboard',
  //     name: 'Dashboard',
  //     component: () => import('@/views/dashboard/index'),
  //     meta: { title: 'Dashboard', icon: 'dashboard' }
  //   }]
  // },
  {
    path: '/',
    component: Layout,
    meta: { title: '发票签收', icon: 'fpqs_g' },
    redirect: 'invoiceSign/sign',
    children: [
      {
        path: 'invoiceSign/sign',
        name: 'Sign',
        component: () => import('@/views/invoice/index'),
        meta: { title: '发票签收', breadcrumb: false }
      }
    ]
  },
  {
    path: '/invoiceTrial',
    component: Layout,
    meta: { title: '发票初审', icon: 'fpcs_g' },
    redirect: '/invoiceTrial/index',
    children: [
      {
        path: 'index',
        name: 'Trial',
        component: () => import('@/views/trial/index'),
        meta: { title: '发票初审', breadcrumb: false }
      },
      {
        path: 'detail',
        name: 'TrialDetail',
        hidden: true,
        component: () => import('@/views/trial/detail'),
        meta: { title: '发票审核详情', activeMenu: '/invoiceTrial/index' }
      }
    ]
  },
  {
    path: '/invoiceReview',
    component: Layout,
    meta: { title: '发票复核', icon: 'fpfh_g' },
    redirect: '/invoiceReview/index',
    children: [
      {
        path: 'index',
        name: 'Review',
        component: () => import('@/views/review/index'),
        meta: { title: '发票复核', breadcrumb: false }
      },
      {
        path: 'detail',
        name: 'ReviewDetail',
        hidden: true,
        component: () => import('@/views/review/detail'),
        meta: { title: '发票复核详情', activeMenu: '/invoiceReview/index' }
      }
    ]
  },
  {
    path: '/communication',
    component: Layout,
    meta: { title: '沟通记录', icon: 'gtjl_g' },
    redirect: '/communication/index',
    children: [
      {
        path: 'index',
        name: 'Communication',
        component: () => import('@/views/record/index'),
        meta: { title: '沟通记录', breadcrumb: false }
      },
      {
        path: 'detail',
        name: 'CommunicationDetail',
        hidden: true,
        component: () => import('@/views/record/detail'),
        meta: { title: '沟通详情', activeMenu: '/communication/index' }
      }
    ]
  },
  {
    path: '/invoiceRefund',
    component: Layout,
    meta: { title: '发票寄回', icon: 'fpjh_g' },
    redirect: '/invoiceRefund/index',
    children: [
      {
        path: 'index',
        name: 'Refund',
        component: () => import('@/views/refund/index'),
        meta: { title: '发票寄回', breadcrumb: false }
      },
      {
        path: 'detail',
        name: 'RefundDetail',
        hidden: true,
        component: () => import('@/views/refund/detail'),
        meta: { title: '发票退回详情', activeMenu: '/invoiceRefund/index' }
      }
    ]
  },
  {
    path: '/invoiceArchive',
    component: Layout,
    meta: { title: '发票归档', icon: 'fpgd_g' },
    redirect: '/invoiceArchive/index',
    children: [
      {
        path: 'index',
        name: 'archive',
        component: () => import('@/views/archive/index'),
        meta: { title: '发票归档', breadcrumb: false }
      },
      {
        path: 'detail',
        name: 'ArchiveDetail',
        hidden: true,
        component: () => import('@/views/archive/detail'),
        meta: { title: '发票归档详情', activeMenu: '/invoiceArchive/index' }
      }
    ]
  },
  {
    path: '/operationRecords',
    component: Layout,
    meta: { title: '发票查询', icon: 'fpcx_g' },
    redirect: '/operationRecords/index',
    children: [
      {
        path: 'index',
        name: 'Operation',
        component: () => import('@/views/operation/index'),
        meta: { title: '发票查询', breadcrumb: false }
      },
      {
        path: 'detail',
        name: 'OperationDetail',
        hidden: true,
        component: () => import('@/views/operation/detail'),
        meta: { title: '记录详情', activeMenu: '/operationRecords/index' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
